module.exports = __webpack_public_path__ + "static/media/Loading_Indicator_double_32.6404640e.svg";